import Vuex from 'vuex'
import Vue from 'vue'
import storage from '../utils/storage'

// 安装插件
Vue.use(Vuex)

// 创建store对象
const store = new Vuex.Store({
    namespaced: true,
    // 存放数据
    state: {
        // 用户登录方式 0-网页、1-企业微信
        userLoginType: storage.get('userLoginType') ? storage.get('userLoginType') : 0,

        // 访问环境
        userAgent: storage.get('userAgent') ? storage.get('userAgent') : 'other',

        // 用户登录方式 0-手动登录，1-快捷登录
        loginType: storage.get('LOGINTYPE') ? storage.get('LOGINTYPE') : 0,

        headActive: storage.get('headActive') ? storage.get('headActive') : 0,

        // 企业微信 userId
        qy_userId: storage.get('QYUSERINFOID') ? storage.get('QYUSERINFOID') : '',

        // 用户信息
        USERINFO: storage.get('USERINFO') ? storage.get('USERINFO') : '',

        // 获取开放id
        OPENID: storage.get('OPENID') ? storage.get('OPENID') : '',

        // 商品数据
        shopItem: '',

        // 菜单权限
        menuItem: storage.get('MENULIST') ? storage.get('MENULIST') : '',

        routerList: storage.get('ROUTERLIST') ? storage.get('ROUTERLIST') : {},

    },

    // 修改state中数据的一些方法
    mutations: {
        // 设置用户登录形式
        setUserLoginType(state, data) {
            storage.set('userLoginType', data);
            state.userLoginType = data;
        },

        // 设置访问环境
        setUserAgent(state, data) {
            storage.set('userAgent', data);
            state.userAgent = data;
        },

        // 修改loginType，并将loginType存入localStorage
        updateLoginType(state, data) {
            storage.set('LOGINTYPE', data);
            state.loginType = data;
        },

        updateHeadActive(state, data) {
            storage.set('headActive', data);
            state.headActive = data;
        },

        // 修改token，并将token存入localStorage
        setQyUserId(state, data) {
            storage.set('QYUSERINFOID', data);
            state.qy_userId = data;
        },

        // 修改用户信息
        updateUserInfo(state, data) {
            storage.set('USERINFO', data);
            state.USERINFO = data;
        },

        // 修改开放id
        updateOpenid(state, data) {
            storage.set('OPENID', data);
            state.OPENID = data;
        },

        // 修改商品
        setShopItem(state, data) {
            state.shopItem = data
        },

        // 修改菜单
        setMenuList(state, data) {
            storage.set("MENULIST", data);
            state.menuItem = data
        },

        cacheRoute(state, { encryptstring, name }) {
            state.routerList[name] = { encryptstring }
            storage.set("ROUTERLIST", state.routerList);
        }
    },

    // 异步方法
    actions: {
        updateCachedRoute({ commit }, { encryptstring, name}) {
            commit('cacheRoute', { encryptstring, name });
        }
    },
})

export default store